import React from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import moment from 'moment';

import PromoCodeForm from '../../../../components/SiteAdmin/PromoCode/PromoCodeForm';
import Loader from '../../../../components/Common/Loader/Loader';
import NotFound from '../../../../components/NotFound/NotFound';
import getPromoCodeQuery from './getPromoCode.graphql';

import messages from '../../../../locale/messages';
import { withQuery } from '../../../../hoc/withGraphql';

class EditPromoCode extends React.Component {
  render() {
    const { promoCode: { loading, getPromoCode } } = this.props;
    const { formatMessage } = this.props.intl;


    let initialValues = {};
    if (!loading && getPromoCode) {
      initialValues = {
        ...getPromoCode?.result,
        expiryDate: getPromoCode && getPromoCode?.result?.expiryDate ? moment(Number(getPromoCode && getPromoCode?.result?.expiryDate)).format('YYYY-MM-DD HH:mm:ss') : null
      };
    }

    if (!loading && !getPromoCode?.result?.id) {
      return <NotFound title={formatMessage(messages.pageNotFound)} />;
    } else {
      return (
        <Loader type={"page"} show={loading}>
          {!loading && <PromoCodeForm initialValues={initialValues} />}
        </Loader>
      );
    }
  }
}

export default compose(
  injectIntl,
  withQuery(getPromoCodeQuery, {
    name: 'promoCode',
    options: (props) => ({
      ssr: false,
      fetchPolicy: 'network-only',
      variables: {
        id: Number(props.id)
      }
    })
  }))(EditPromoCode);
